/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const manageExecution = /* GraphQL */ `
  mutation ManageExecution(
    $args: AWSJSON!
    $command: ExecutionManagerCommand!
  ) {
    manageExecution(args: $args, command: $command)
  }
`;
export const manageResource = /* GraphQL */ `
  mutation ManageResource($args: AWSJSON!, $command: ResourceManagerCommand!) {
    manageResource(args: $args, command: $command)
  }
`;
export const mutateExecution = /* GraphQL */ `
  mutation MutateExecution(
    $clientAccountId: ID!
    $executionId: ID!
    $mutationType: MutationType!
    $payload: AWSJSON!
    $workloadId: ID!
  ) {
    mutateExecution(
      clientAccountId: $clientAccountId
      executionId: $executionId
      mutationType: $mutationType
      payload: $payload
      workloadId: $workloadId
    ) {
      clientAccountId
      executionId
      mutationType
      payload
      workloadId
    }
  }
`;
export const mutateExecutionInput = /* GraphQL */ `
  mutation MutateExecutionInput(
    $clientAccountId: ID!
    $executionId: ID!
    $inputUri: ID!
    $mutationType: MutationType!
    $payload: AWSJSON!
    $workloadId: ID!
  ) {
    mutateExecutionInput(
      clientAccountId: $clientAccountId
      executionId: $executionId
      inputUri: $inputUri
      mutationType: $mutationType
      payload: $payload
      workloadId: $workloadId
    ) {
      clientAccountId
      executionId
      inputUri
      mutationType
      payload
      workloadId
    }
  }
`;
export const mutateLogQueryResult = /* GraphQL */ `
  mutation MutateLogQueryResult($payload: AWSJSON!, $queryId: ID!) {
    mutateLogQueryResult(payload: $payload, queryId: $queryId) {
      payload
      queryId
    }
  }
`;
export const mutateResource = /* GraphQL */ `
  mutation MutateResource(
    $clientAccountId: ID!
    $mutationType: MutationType!
    $payload: AWSJSON!
    $resourceId: ID!
    $resourceType: ResourceType!
  ) {
    mutateResource(
      clientAccountId: $clientAccountId
      mutationType: $mutationType
      payload: $payload
      resourceId: $resourceId
      resourceType: $resourceType
    ) {
      clientAccountId
      mutationType
      payload
      resourceId
      resourceType
    }
  }
`;
export const upsertUser = /* GraphQL */ `
  mutation UpsertUser($data: String, $type: UserDataType!) {
    upsertUser(data: $data, type: $type) {
      Data
      Id
      LastUpdate
      Type
    }
  }
`;
